import { Box, Typography } from "@mui/material";
import { React, useState, useEffect } from "react";
import { styled } from "@mui/material/styles";
import { colors } from "../../../assets/colors";
import { apiRouterCall } from "../../../api/services";
import { useNavigate } from "react-router-dom";

const AnnouncementContainer = styled(Box)(({ theme }) => ({
  // marginTop: "50px",

  width: "100%",
  background:
    "linear-gradient(90deg, #FFCA65 5.12%, rgba(204, 120, 41, 0.92) 105.64%)",
  [theme.breakpoints.down("md")]: {
    marginTop: "50px !important", // Padding for screen sizes equal to or wider than 'md'
  },
  [theme.breakpoints.down("sm")]: {
    marginTop: "40px ", // Padding for screen sizes equal to or wider than 'sm'
  },
  [theme.breakpoints.down("xs")]: {
    marginTop: "50px ", // Padding for screen sizes equal to or wider than 'md'
  },
}));

const TextWrapper = styled(Box)({
  display: "flex",
  top: "12px",
});

const AnnounceText = styled(Typography)({
  marginRight: "20px", // Adjust the space between texts
  color: colors.black,
});

export default function Announcement() {
  const [allData, setAllData] = useState([]);
  const navigate = useNavigate();

  const dataHandler = async () => {
    try {
      const response = await apiRouterCall({
        method: "GET",
        endPoint: "announcmentList",
      });
      if (response?.data?.responseCode === 200) {
        setAllData(response?.data?.result?.docs);
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    dataHandler();
  }, []);

  const slicedArray = allData.slice(0, 5);

  return (
    <AnnouncementContainer>
      <Box className="mainContainer">
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Box sx={{ marginRight: "10px" }}>
            <img
              src="/assets/icons/announcement.png"
              alt="announcement_icon"
              style={{ display: "flex" }}
            />
          </Box>
          <Box className="announcement-stripe">
            <TextWrapper className="announcement-text">
              {slicedArray &&
                slicedArray?.map((item, index) => (
                  <AnnounceText
                    variant="h5"
                    key={`s${index}`}
                    sx={{ cursor: "pointer" }}
                    onClick={() =>
                      navigate(
                        `/resources/all?${item?.title
                          ?.split(" ")
                          .map((x) => x.toLowerCase())
                          ?.join("-")}`
                      )
                    }
                  >
                    #{item?.title}
                  </AnnounceText>
                ))}
            </TextWrapper>
          </Box>
        </Box>
      </Box>
    </AnnouncementContainer>
  );
}
